var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdvCommonContainer',{attrs:{"adv-master-id":_vm.HOME_ADV_ID_MAP.ACTION_BTN_CORNER,"custom-class-name":_vm.$style.actionBtnCornerAdv}})}
var staticRenderFns = []

export { render, staticRenderFns }